var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticStyle:{"border-radius":"4px"},attrs:{"value":_vm.percentage,"background-color":"white","indeterminate":!_vm.percentage,"color":"tretiary","height":"25"}})}
var staticRenderFns = []

export { render, staticRenderFns }